import 'css-chunksrc/client/scenes/optimizedGantt/workloads/styles.scss';export default {
  "workLoads": "_workLoads_9br8o_1",
  "calendar": "_calendar_9br8o_7"
};